import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamond = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.52674 13.2374C0.843326 12.554 0.843326 11.446 1.52674 10.7626L10.7988 1.49049C11.4822 0.807067 12.5903 0.807069 13.2737 1.49049L22.5458 10.7626C23.2292 11.446 23.2292 12.554 22.5458 13.2374L13.2737 22.5095C12.5903 23.1929 11.4822 23.1929 10.7988 22.5095L1.52674 13.2374ZM2.5874 11.8232C2.48977 11.9209 2.48977 12.0791 2.5874 12.1768L11.8595 21.4489C11.9571 21.5465 12.1154 21.5465 12.213 21.4489L21.4851 12.1768C21.5827 12.0791 21.5827 11.9209 21.4851 11.8232L12.213 2.55115C12.1154 2.45351 11.9571 2.45351 11.8595 2.55115L2.5874 11.8232Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgDiamond;
